import { action } from 'easy-peasy';

import { IActionSetAllocatedClients } from '../types';

const setAllocatedClients: IActionSetAllocatedClients = action((state, payload) => {
  state.allocatedClients = payload;
});

export default setAllocatedClients;
